module.exports = __webpack_public_path__ + "static/media/YF99_2.0e18d90b.jpg";